import React from 'react';
import PropTypes from 'prop-types';
import { Box, SvgIcon } from '@mui/material';

function AppStoreLinks({ inline }) {
  return (
    <Box sx={[{ marginTop: '10px', display: 'flex', flexDirection: 'column' }, inline && { flexDirection: 'row' }]}>
      <Box
        component="a"
        href="https://apps.apple.com/de/app/komm-kickern/id1483083379"
        rel="noreferrer"
        target="_blank"
        sx={
          inline
            ? (theme) => ({
                textDecoration: 'none',
                marginRight: '26px',
                marginTop: '12px',
                '&:last-child': {
                  marginRight: '0px',
                },
                [theme.breakpoints.down('md')]: {
                  marginRight: '12px',
                },
              })
            : { margin: '6px auto', textDecoration: 'none' }
        }
      >
        <SvgIcon
          sx={(theme) => ({
            width: '170px',
            height: '56px',
            [theme.breakpoints.down('md')]: {
              width: '150px',
            },
          })}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 195 64"
        >
          <g fill="none" fillRule="evenodd">
            <g>
              <g transform="translate(-150 -547) translate(150 547)">
                <rect width="195" height="64" fill="#FFF" rx="32" />
                <path
                  fill="#000"
                  fillRule="nonzero"
                  d="M47.789 42.074c-1.332 1.928-2.71 3.844-4.886 3.884-2.141.04-2.828-1.255-5.27-1.255-2.447 0-3.212 1.215-5.233 1.295-2.1.078-3.698-2.082-5.04-4.001-2.745-3.925-4.84-11.096-2.022-15.936 1.394-2.403 3.894-3.924 6.602-3.964 2.062-.037 4.011 1.376 5.27 1.376 1.263 0 3.628-1.697 6.114-1.448 1.04.042 3.962.415 5.838 3.132-.149.096-3.487 2.018-3.446 6.023.04 4.783 4.235 6.373 4.284 6.395-.038.112-.67 2.27-2.211 4.499zm-8.18-24.777c1.067-1.28 2.871-2.233 4.36-2.297.19 1.778-.51 3.56-1.542 4.842-1.034 1.281-2.728 2.28-4.39 2.146-.226-1.74.612-3.554 1.572-4.691z"
                />
                <g fill="#000">
                  <text fontFamily="Roboto-Regular, Roboto" fontSize="10" transform="translate(62 14)">
                    <tspan x="0" y="9">
                      Download on
                    </tspan>
                  </text>
                  <text fontFamily="Roboto-Medium, Roboto" fontSize="20" fontWeight="500" transform="translate(62 14)">
                    <tspan x="0" y="32">
                      App Store
                    </tspan>
                  </text>
                </g>
              </g>
            </g>
          </g>
        </SvgIcon>
      </Box>
      <Box
        component="a"
        href="https://play.google.com/store/apps/details?id=de.silpion.kki_player"
        rel="noreferrer"
        target="_blank"
        sx={
          inline
            ? (theme) => ({
                textDecoration: 'none',
                marginRight: '26px',
                marginTop: '12px',
                '&:last-child': {
                  marginRight: '0px',
                },
                [theme.breakpoints.down('md')]: {
                  marginRight: '12px',
                },
              })
            : { margin: '6px auto', textDecoration: 'none' }
        }
      >
        <SvgIcon
          sx={(theme) => ({
            width: '170px',
            height: '56px',
            [theme.breakpoints.down('md')]: {
              width: '150px',
            },
          })}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 195 64"
        >
          <g fill="none" fillRule="evenodd">
            <g>
              <g transform="translate(-377 -547) translate(377 547)">
                <rect width="195" height="64" fill="#FFF" rx="32" />
                <path
                  fill="#000"
                  fillRule="nonzero"
                  d="M24 45.811V18.192c0-.964.548-1.797 1.342-2.192L41 31.997 25.336 48C24.545 47.603 24 46.772 24 45.811zm22-9.06L29 47l13.407-14L46 36.751zm5.121-6.653c.534.438.879 1.129.879 1.905 0 .765-.334 1.447-.855 1.886L47.734 36 44 31.999 47.731 28l3.39 2.098zM29 17l17 10.249L42.408 31 29 17z"
                />
                <g fill="#000">
                  <text fontFamily="Roboto-Regular, Roboto" fontSize="10" transform="translate(64 14)">
                    <tspan x="0" y="9">
                      Download on
                    </tspan>
                  </text>
                  <text fontFamily="Roboto-Medium, Roboto" fontSize="20" fontWeight="500" transform="translate(64 14)">
                    <tspan x="0" y="32">
                      Google Play
                    </tspan>
                  </text>
                </g>
              </g>
            </g>
          </g>
        </SvgIcon>
      </Box>
    </Box>
  );
}

AppStoreLinks.propTypes = {
  inline: PropTypes.bool,
};

AppStoreLinks.defaultProps = {
  inline: false,
};

export default AppStoreLinks;
